













import { Vue, Component, Prop } from 'vue-property-decorator'
import { Button as IButton } from '.'

@Component
export default class Button extends Vue {
  // TODO icon
  @Prop({ type: Object, required: true }) preset!: IButton

  handleClick() {
    this.$emit('click', this.preset.event)
  }
}
